import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Button } from 'react-bootstrap';
import React, { useRef } from 'react';
import useMonitorAPIService from '../../services/monitorapiservice';
import DualListBox from 'react-dual-listbox';
import { useState, useEffect } from "react";
import Toastr from '../utils/toastr';

function AgentGroups(props) {

    const { t } = useTranslation();
    const toastrRef = useRef(null);
    const { addRemoveUserGroups } = useMonitorAPIService();
    const [selected, setSelected] = useState([]);
    const prevAgent = useRef();
    const prevSelected = useRef();

    useEffect(() => {

        if ((!prevAgent.current && props.agent)
            || (props.agent && prevAgent.current && props.agent.userId !== prevAgent.current.userId)
            || (JSON.stringify(prevSelected.current) !== JSON.stringify(props.userGroups))) {
            setSelected(props.userGroups.map(x => x.grpId));
        }

        prevAgent.current = props.agent;
        prevSelected.current = props.userGroups;
    }, [props.agent, props.userGroups]);


    const saveGroups = (e) => {
        var add = {
            pin: props.agent.pin,
            groups: selected.sort((a, b) => a - b)
        };

        var remove = {
            pin: props.agent.pin,
            groups: props.groups.map(x => x.value).filter(x => selected.indexOf(x) == -1).sort((a, b) => a - b)
        };

        var data = {
            add: add,
            remove: remove
        };

        addRemoveUserGroups(props.token, JSON.stringify(data), res => {

            if (res.data) {
                toastrRef.current.setType("success");
                toastrRef.current.setMessage(t("dataupdated"));
                toastrRef.current.show();
            } else {
                toastrRef.current.setType("error");
                toastrRef.current.setMessage(t("error"));
                toastrRef.current.show();
            }

        });

    };


    return (
        <div className={"card card-flush overflow-hidden"} >
            <div className="card-header ">
                <h3 className="card-title align-items-start flex-column text-primary">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("user-group")} /> {t("groups")}</span>

                </h3>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem" }}>
                <DualListBox
                    options={props.groups}
                    selected={selected}
                    onChange={(value) => setSelected(value)}
                    disabled={!props.functions.changeUserGroup}
                    icons={{
                        moveLeft: <FontAwesomeIcon icon={duotone("left")} />,
                        moveAllLeft: [
                            <FontAwesomeIcon key={0} icon={duotone("left")} />,
                            <FontAwesomeIcon key={1} icon={duotone("left")} />,
                        ],
                        moveRight: <FontAwesomeIcon icon={duotone("right")} />,
                        moveAllRight: [
                            <FontAwesomeIcon key={0} icon={duotone("right")} />,
                            <FontAwesomeIcon key={1} icon={duotone("right")} />,
                        ]
                    }}
                />
                <br />
                {
                    props.functions.changeUserGroup &&
                    <Button variant="primary" onClick={saveGroups}>
                        <FontAwesomeIcon icon={duotone("floppy-disk")} /> {t("savegroups")}
                    </Button>}
            </div>
            <Toastr ref={toastrRef} />
        </div>

    )
}

const mapStateToProps = (state) => {
    return {
        functions: state.supervisor.functions,
        token: state.supervisor.token
    };
};

export default connect(mapStateToProps, {})(AgentGroups);